import AboutSettingsPanel from './About';
import AppearanceSettingsPanel from './Appearance';
import GeneralSettingsPanel from './General';
import IntegrationsSettingsPanel from './Integrations';
import NotificationsSettingsPanel from './Notifications';
import StagingSettingsPanel from './Staging';
import WorkspaceGeneralSettingsPanel from './WorkspaceGeneral';
import WorkspaceMembersSettingsPanel from './WorkspaceMembers';
import { capitalize } from '@support/string';
import HomeSettingsPanel from './Home';
import ProfileSettingsPanel from './Profile';

export type SettingsPanel =
  | 'general'
  | 'profile'
  | 'home'
  | 'integrations'
  | 'notifications'
  | 'appearance'
  | 'about'
  | 'staging'
  | 'workspace-general'
  | 'workspace-members';

export type IntegrationsSubPanel = 'card-dav' | 'zapier';
export type SettingsSubPanel = IntegrationsSubPanel;

export interface SettingsNavState {
  panel: SettingsPanel;
  subPanel?: SettingsSubPanel;
}

export const panelTitle = (panel: SettingsPanel): string => {
  if (panel === 'workspace-general') {
    return 'Preferences';
  } else if (panel.startsWith('workspace-')) {
    return capitalize(panel.split('-').slice(1).join(' '));
  }
  return capitalize(panel.split('-').join(' '));
};

export const subPanelTitle = (subPanel: SettingsSubPanel): string => {
  switch (subPanel) {
    case 'card-dav':
      return 'Address Book (CardDAV)';
    case 'zapier':
      return 'Zapier';
    default:
      return capitalize(subPanel);
  }
};

const componentForPanel = {
  'general': GeneralSettingsPanel,
  'profile': ProfileSettingsPanel,
  'home': HomeSettingsPanel,
  'integrations': IntegrationsSettingsPanel,
  'notifications': NotificationsSettingsPanel,
  'appearance': AppearanceSettingsPanel,
  'about': AboutSettingsPanel,
  'staging': StagingSettingsPanel,
  'workspace-general': WorkspaceGeneralSettingsPanel,
  'workspace-members': WorkspaceMembersSettingsPanel,
};

export default componentForPanel;
